import { useRef } from "react";

export const useDebounce = () => {
    const isCooldown = useRef(false);
    const timeoutId = useRef<NodeJS.Timeout | null>(null);
    const debouncedFunction = <T extends (...args: any[]) => void>(callback: T, delay: number) => {
        return (...args: Parameters<T>) => {
            if (isCooldown.current) return;
            callback(...args);
            isCooldown.current = true;
            if (timeoutId.current) {
                clearTimeout(timeoutId.current);
            }
            timeoutId.current = setTimeout(() => {
                isCooldown.current = false;
            }, delay);
        };
    };
    return { debouncedFunction };
};
